export default {
  form: {
    bank_account_number: {
      label: 'Număr de cont',
      placeholder: 'DE01101234567891234567',
    },
    bank_routing_number: {
      label: 'Cod de rutare',
      placeholder: '110000000',
    },
    bank_country: {
      label: 'Țară',
      placeholder: 'Germania',
    },
    bank_statement_descriptor: {
      label: 'Descriptor extras de cont',
      placeholder: 'Numele restaurantului',
      tooltip: 'Acest nume va apărea pe extrasele bancare ale clienților',
    },
  },
  buttons: {
    next: 'Înainte',
    back: 'Înapoi',
    use_test_data: 'Folosește date de test',
  },
  test_data_hint: 'Cont bancar de test acceptat de {{gateways}}',
  read_only_warning:
    'Informațiile bancare pot fi modificate doar de echipa noastră. Dacă doriți să le actualizați, vă rugăm contactați suportul.',
};
